export const writeReviewGuidelines = 'review-guidelines-overlay';
